import { toast } from "react-toastify";
import axiosInstance from "../axiosInterceptor";

export async function GET(url) {
  try {
    const response = await axiosInstance.get(url);
    const data = response;
    return data;
  } catch (error) {
    if (error.response) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      return error?.response;
    } else if (error.request) {
      return error?.request;
    } else {
      return error?.message;
    }
  }
}

export async function POST(url, payload) {
  try {
    const response = await axiosInstance.post(url, payload);
    return { success: true, data: response.data, status: response.status };
  } catch (error) {
    if (error.response) {
      toast.error(error.response.data.message || "Something went wrong");
      if (error?.response?.data?.errors.length > 0) {
        toast.error(error.response.data.message || "Something went wrong");
      } else {
        toast.error(error?.response?.data?.message || "Something went wrong");
      }
      return {
        success: false,
        data: error.response.data,
        status: error.response.status,
      };
    } else if (error.request) {
      return {
        success: false,
        data: "No response received from the server.",
        request: error.request,
      };
    } else {
      return { success: false, data: error.message };
    }
  }
}

export async function PUT(url, payload) {
  try {
    const response = await axiosInstance.put(url, payload);
    const data = response;
    return data;
  } catch (error) {
    if (error.response) {
      if (error?.response?.data?.errors.length > 0) {
        toast.error(error?.response?.data?.errors[0].message || "Something went wrong");
      } else {
        toast.error(error?.response?.data?.message || "Something went wrong");
      }
      return error?.response;
    } else if (error.request) {
      return error?.request;
    } else {
      return error?.message;
    }
  }
}

export async function DELETE(url) {
  try {
    const response = await axiosInstance.delete(url);
    const data = response;
    return data;
  } catch (error) {
    if (error.response) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      return error?.response;
    } else if (error.request) {
      return error?.request;
    } else {
      return error?.message;
    }
  }
}

export async function DELETEDATA(url, payload) {
  try {
    const response = await axiosInstance.delete(url, payload);
    const data = response;
    return data;
  } catch (error) {
    if (error.response) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      return error?.response;
    } else if (error.request) {
      return error?.request;
    } else {
      return error?.message;
    }
  }
}
